// Map of popular cities to their ISO 3166-1 alpha-2 country codes
  const cityToCountry = {
    'london': 'GB',
    'paris': 'FR',
    'new york': 'US',
    'tokyo': 'JP',
    'dubai': 'AE',
    'singapore': 'SG',
    'bangkok': 'TH',
    'istanbul': 'TR',
    'hong kong': 'HK',
    'rome': 'IT',
    'barcelona': 'ES',
    'kuala lumpur': 'MY',
    'macau': 'MO',
    'shenzhen': 'CN',
    'istanbul': 'TR',
    'madrid': 'ES',
    'berlin': 'DE',
    'amsterdam': 'NL',
    'seoul': 'KR',
    'los angeles': 'US',
    'mumbai': 'IN',
    'cairo': 'EG',
    'mexico city': 'MX',
    'beijing': 'CN',
    'buenos aires': 'AR',
    'taipei': 'TW',
    'sydney': 'AU',
    'melbourne': 'AU',
    'perth': 'AU',
    'brisbane': 'AU',
    'canberra': 'AU',
    'adelaide': 'AU',
    'gold coast': 'AU',
    'newcastle': 'AU',
    'new delhi': 'IN',
    'hyderabad': 'IN',
    'chennai': 'IN',
    'bangalore': 'IN',
    'ahmedabad': 'IN',
    'surat': 'IN',
    'pune': 'IN',
    'kolkata': 'IN',
    'delhi': 'IN',
    'chicago': 'US'
  };

  export default cityToCountry;